import { render, staticRenderFns } from "./PortfolioDetails.vue?vue&type=template&id=58dd0ac2&"
import script from "./PortfolioDetails.vue?vue&type=script&lang=js&"
export * from "./PortfolioDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports